import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { useRef } from "react";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const session_id = decodeURIComponent(m[1]);
    const pendingRole = sessionStorage.getItem("hm_pending_role") || "student";
    sessionStorage.removeItem("hm_pending_role");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id, role: pendingRole });
        if (data.access_token) localStorage.setItem("hm_token", data.access_token);
        setUser(data.user);
        const dest = data.user?.role === "handyman" ? "/handyman" : "/dashboard";
        window.history.replaceState({}, "", dest);
        nav(dest, { state: { user: data.user } });
      } catch {
        nav("/login");
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <p className="text-charcoal/70 font-display text-xl animate-pulse">Signing you in…</p>
    </div>
  );
}
